import React from 'react'
// context
import { ObjectiveContext } from 'context/index'
// constants
import { ENTITIES } from 'constants/index'
// view components
import ReviewsListContainer from 'containers/Review/ReviewList'

const ObjectiveReviewsList: React.FC = () => {
  const { entity } = React.useContext(ObjectiveContext) as any

  const {
    objectiveCreateScheduledReview,
    objectiveDeleteScheduledReview,
    objectiveModifyScheduledReview,
    objectiveViewCompletedReview,
    objectiveViewInProgressReview
  } = entity.currentPermissions

  return (
    <ReviewsListContainer
      canCreate={objectiveCreateScheduledReview}
      canDelete={objectiveDeleteScheduledReview}
      canModify={objectiveModifyScheduledReview}
      canViewCompleted={objectiveViewCompletedReview}
      canViewInProgress={objectiveViewInProgressReview}
      entity={{ ...entity, entityType: ENTITIES.PLAN_OBJECTIVE }}
    />
  )
}

export default ObjectiveReviewsList
